import React, { useState } from "react";
import SearchForm from "./searchForm.tsx";
import MadagascarMap from "../madagascarMap.tsx";
import ComplaintsChart from "../complaintChart.tsx";
import ComplaintCategoryReport from "../complaintCategoryReport.tsx";
import ComplaintReportTable from "./ComplaintReportTable.tsx";
import { ChartOptions } from "chart.js";
import Upload from "./upload.tsx";
import {  useAppSelector } from "@core/store/hook.ts";
import { dashboardExterneData } from "@core/slice/DashboardExterneSlice.ts";
import Spinner from "@shared/Spinner.tsx";
import { FetchStatusType } from "@core/modeles/model.ts";
import { Toast } from "primereact/toast";


const ExternalAgentDashboard: React.FC = () => {
  const dataDashboard = useAppSelector(dashboardExterneData);

  const [showUpload, setShowUpload] = React.useState<boolean>(false)
  const [hasOneValueSearch, setHasOneValueSearch] = React.useState<boolean>(false)

  const toastRef = React.useRef<Toast>(null);

  const [importFinished, setImportFinished] = useState(false);
  const [dataRequest, setDataRequest] = useState<any>({
    dateDebut: "",
    dateFin: "",
    typePlainte: "",
    region: "",
    district: "",
    commune: "",
    fokontany: "",
  });

  const isEmptyDonut = dataDashboard.dataExtern?.donut.length === 0
  const isEmptyTable = dataDashboard.dataExtern?.tableaux.length === 0

const showMessage : any = (
  severity: 'success' | 'info' | 'warn' | 'error',
  summary: string, 
  detail: string | React.ReactNode
) => {
  toastRef.current?.show({
    severity,summary, detail,life : 15000
  })
}

  // --------------------- Etat du téléchargement pour réinitialiser le recherche
  const isImported = () => {    
    setImportFinished(true);
  };

  const handleSearch = (data: any) => {
    setDataRequest(data);
    const val = Object.values(data).some(value => value !== "")
    setHasOneValueSearch(val)
  };
  const dataReportBarChart = {
    labels: dataDashboard.dataExtern?.diagram.map((item) => {
      if (item.category === "PH_AND_PA") {
        return "PH/PA";
      }
      return item.category;
    }),
    datasets: [
      {
        label: "Nombre de plaintes",
        data: dataDashboard.dataExtern?.diagram.map((item) => item.nombre),
        backgroundColor: "rgba(54, 162, 235, 0.8)",
        categoryPercentage: 0.3,
        barPercentage: 0.5,
        borderRadius: 10,
      },
    ],
  };

  const dataToComplaintsChart = {
    labels: dataDashboard.dataExtern?.donut.map((item) => item.status) as string[] || [], 
    values : dataDashboard.dataExtern?.donut.map((item) => item.nombre) as number[] || [],
  };

  const count = dataDashboard.dataExtern?.donut.reduce((acc, item) => acc + item.nombre, 0) || 0;

  const optionsReportBarChart: ChartOptions<"bar"> = {
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        type: "category",
        grid: {
          display: false,
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return (value as number) * 10;
          },
        },
      },
    },
  };

  const handleShowUpload=()=>{
    setImportFinished(false);
    if(showUpload === true){
      setShowUpload(false)
    }
    else setShowUpload(true)
  }


  return (
    <div className="w-full">
      <Toast ref={toastRef} />

      <div className="search-widget">
        <SearchForm toRealod={importFinished} onSearch={handleSearch} setHasOneValueSearch={setHasOneValueSearch} />
      </div>

      {dataDashboard.loading === FetchStatusType.LOADING && (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      )}

      {dataDashboard.loading === FetchStatusType.COMPLETED &&
        (isEmptyDonut && isEmptyTable && hasOneValueSearch ? (
          <>
            <div className="w-full flex justify-center items-center mt-5 text-lg"><p>Aucune plainte trouvée</p></div>
          </>
        ) : (
          <>
            <div className="map-widget">
              <div className="my-4 lg:flex">
                <div className="w-full flex items-center">
                  <MadagascarMap dataMap={dataDashboard.dataExtern?.card} />
                </div>
                <div className="w-full flex flex-col justify-around md:gap-5">
                    <ComplaintsChart
                      title="Statut des plaintes"
                      databyParent={dataToComplaintsChart}
                      count={count}
                    />
                    <ComplaintCategoryReport
                      title={"Rapport de plainte par catégorie"}
                      data={dataReportBarChart}
                      options={optionsReportBarChart}
                    />
                </div>
              </div>
            </div>
            {showUpload && (
              <Upload
                handleShowUpload={handleShowUpload}
                showUpload={showUpload}
                setShowUpload={setShowUpload}
                showMessage={showMessage}
                isImported={isImported}
              />
            )}
            <div className="mt-5 grid gap-4 w-full">
              <ComplaintReportTable
                dataRequest={dataRequest}
                handleShowUpload={handleShowUpload}
                dataTableList={dataDashboard.dataExtern?.tableaux}
              />
            </div>
          </>
        ))}
    </div>
  );
};

export default ExternalAgentDashboard;
